<disclaimer text="{{ 'VARIETY.NO_DATA' | translate }}"></disclaimer>
